export enum RootCategory {
  InteractiveVideo = 1,
  News = 4,
}


export enum TestQuestionType {
  MultipleChoise = 1,
  Checklist = 2,
  GapFill = 3,
  ShortAnswer = 4,
  ShortAnswerGoogleTextToSpeed = 5,
  TrueFalse = 6,
  TrueFalseNotGiven = 7,
  YesNo = 8,
  Matching = 9,
  Listing = 10,
  ExerciseInstruction = 11,
  VideoLessonForumQuestion = 12,
}

export enum LcmsCurriculumType {
  Unit = 1,
  LessonInteractive = 11,
}

export enum TimeCodeQuestionType {
  InteractiveQuestions = 1,
  StandAloneQuestions = 2,
}
export enum UserTypeId {
  User = 1,
  LLB = 2,
}
